module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp13_7016.98b4c8d1.png";